import React from "react";
import Moment from "react-moment";

export default ({ data }) => (data ? <Moment format="DD/MM/YYYY h:mm:ss A" titleFormat="DD/MM/YYYY h:mm:ss A" withTitle>{data}</Moment> : null);
